import React, { useState } from 'react';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPasswordForm from './ForgotPasswordForm';

const AuthPage = () => {
  const [currentView, setCurrentView] = useState('login'); // 'login', 'register', 'forgot'

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {currentView === 'login' && (
          <LoginForm 
            onSwitchToRegister={() => setCurrentView('register')}
            onSwitchToForgot={() => setCurrentView('forgot')}
          />
        )}
        {currentView === 'register' && (
          <RegisterForm onSwitchToLogin={() => setCurrentView('login')} />
        )}
        {currentView === 'forgot' && (
          <ForgotPasswordForm onBack={() => setCurrentView('login')} />
        )}
        
        <div className="mt-8 text-center">
          <div className="flex items-center justify-center space-x-4 text-sm text-gray-500">
            <span className="font-semibold">Task Tweak</span>
            <span>•</span>
            <span>Organize. Prioritize. Achieve.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;